import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import GlobalStyled from './sytles/global';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <GlobalStyled />
  </React.StrictMode>,
);
